import { render, staticRenderFns } from "./ModalAddLesson.vue?vue&type=template&id=7e637fb5&scoped=true&"
import script from "./ModalAddLesson.vue?vue&type=script&lang=js&"
export * from "./ModalAddLesson.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddLesson.vue?vue&type=style&index=0&id=7e637fb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e637fb5",
  null
  
)

export default component.exports